import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localizePath } from "@/lib/localePath";

/** <Link> that prefixes `to` with the active locale (en = no prefix). */
export const LocaleLink = ({ to, ...rest }) => {
  const { i18n } = useTranslation();
  return <Link to={localizePath(to, i18n.language)} {...rest} />;
};

/** <NavLink> variant (keeps isActive styling against the localized path). */
export const LocaleNavLink = ({ to, ...rest }) => {
  const { i18n } = useTranslation();
  return <NavLink to={localizePath(to, i18n.language)} {...rest} />;
};
